import { parseColorValue, parseFontName, parseStrokeWidth } from "../../utils/order/customAttributes";
import React from "react";
import { CustomAttribute } from "../../models/customAttribute";


type VisibleAttributesProps = {
  visibleAttrs: CustomAttribute[];
};

export function VisibleAttributes({ visibleAttrs }: VisibleAttributesProps) {
  return <ul>
    {visibleAttrs.map(({ key, value }) => {
      const colorValue = parseColorValue(value);
      const fontName = parseFontName(value);
      const strokeWidth = parseStrokeWidth(value);
      const otherValue = !colorValue && !fontName && !strokeWidth ? value : null;

      return (
        <li key={key}>
            {key}:
            <ul>
              {fontName && <li> Font: {fontName}</li>}
              {strokeWidth && <li> Width: {strokeWidth}</li>}
              {colorValue && <li>
                <div style={{display: 'flex', alignItems: 'center'}}>
                  <i style={{ marginLeft: 5 }}>{colorValue.name}</i>
                  <div
                    style={{
                      marginLeft: 10,
                      width: 20,
                      height: 20,
                      borderRadius: 4,
                      border: '1px solid #999',
                      backgroundColor: colorValue.hex,
                      color: colorValue.hex,
                      fontSize: 10,
                    }}
                  >!
                  </div>
                </div>
              </li>}
              {otherValue && <li>{otherValue}</li>}
            </ul>
        </li>
      );
    })}
  </ul>
}